import { AppTypes } from '../types/apps/apps.types';
import { RecordStatus } from '../types/menu/enums.types';
import { PermissionLevel, PermissionType, RoleTypeEnum } from '../types/public/enum.types';
import { UserRoleType } from '../types/user-roles/user-roles.types';
import { defaultBartenderPermission } from './DefaultRolesPermission/Bartender';
import { defaultBusserPermission } from './DefaultRolesPermission/Busser';
import { defaultCashierPermissions } from './DefaultRolesPermission/Cashier';
import { defaultCookPermission } from './DefaultRolesPermission/Cook';
import { defaultDeliveryServiceDriver } from './DefaultRolesPermission/DeliveryServiceDriver';
import { defaultDishWasherPermission } from './DefaultRolesPermission/DishWasher';
import { defaultGmPermissions } from './DefaultRolesPermission/Gm';
import { defaultJanitorialPermission } from './DefaultRolesPermission/Janitorial';
import { defaultLineCook } from './DefaultRolesPermission/LineCook';
import { defaultManagerPermissions } from './DefaultRolesPermission/Manager';
import { defaultOwnerPermission } from './DefaultRolesPermission/Owner';
import { defaultServerPermission } from './DefaultRolesPermission/Server';
import { defaultShiftAssistanceManager } from './DefaultRolesPermission/ShiftOrAssistantManager';
import { userPermissionContent } from './userPermissionContent';

type RoleList = {
  id?: number;
  roleName: string;
  key: UserRoleType | `${UserRoleType}`;
  status: RecordStatus | `${RecordStatus}`;
  roleType: RoleTypeEnum | `${RoleTypeEnum}`;
  tag: Array<string>;
  createdBy: 'System';
}[];

export const rolesList: RoleList = [
  {
    id: 1,
    roleName: 'Super Admin',
    key: 'super-admin',
    status: 'Active',
    roleType: 'InternalUser',
    tag: ['FOH'],
    createdBy: 'System',
  },
  {
    id: 2,
    roleName: 'Operation',
    key: 'operation',
    status: 'Active',
    roleType: 'InternalUser',
    tag: ['FOH'],
    createdBy: 'System',
  },
  {
    id: 3,
    roleName: 'AIO Buddy',
    key: 'aio-buddy',
    status: 'Active',
    roleType: 'InternalUser',
    tag: ['FOH'],
    createdBy: 'System',
  },
  { id: 4, roleName: 'Owner', key: 'owner', status: 'Active', roleType: 'Employee', tag: ['FOH'], createdBy: 'System' },
  {
    id: 5,
    roleName: 'Manager',
    key: 'manager',
    status: 'Active',
    roleType: 'Employee',
    tag: ['FOH'],
    createdBy: 'System',
  },
  {
    id: 6,
    roleName: 'Server',
    key: 'server',
    status: 'Active',
    roleType: 'Employee',
    tag: ['FOH'],
    createdBy: 'System',
  },
  { id: 7, roleName: 'Cook', key: 'cook', status: 'Active', roleType: 'Employee', tag: ['BOH'], createdBy: 'System' },
  {
    id: 8,
    roleName: 'Bartender',
    key: 'bartender',
    status: 'Active',
    roleType: 'Employee',
    tag: ['FOH'],
    createdBy: 'System',
  },
  {
    id: 9,
    roleName: 'Cashier',
    key: 'cashier',
    status: 'Active',
    roleType: 'Employee',
    tag: ['FOH'],
    createdBy: 'System',
  },
  {
    id: 10,
    roleName: 'Busser',
    key: 'busser',
    status: 'Active',
    roleType: 'Employee',
    tag: ['FOH'],
    createdBy: 'System',
  },
  {
    id: 11,
    roleName: 'Delivery Service Driver',
    key: 'delivery-service-driver',
    status: 'Active',
    roleType: 'Employee',
    tag: ['FOH'],
    createdBy: 'System',
  },
  {
    id: 12,
    roleName: 'Line Cook',
    key: 'line-cook',
    status: 'Active',
    roleType: 'Employee',
    tag: ['BOH'],
    createdBy: 'System',
  },
  {
    id: 13,
    roleName: 'Shift or Assistant Manager',
    key: 'shift-or-assistant-manager',
    status: 'Active',
    roleType: 'Employee',
    tag: ['FOH'],
    createdBy: 'System',
  },
  {
    id: 14,
    roleName: 'BarBack',
    key: 'barback',
    status: 'Active',
    roleType: 'Employee',
    tag: ['BOH'],
    createdBy: 'System',
  },
  { id: 15, roleName: 'GM', key: 'gm', status: 'Active', roleType: 'Employee', tag: ['FOH'], createdBy: 'System' },
  {
    id: 16,
    roleName: 'Dish Washer',
    key: 'dish-washer',
    status: 'Active',
    roleType: 'Employee',
    tag: ['BOH'],
    createdBy: 'System',
  },
  {
    id: 17,
    roleName: 'Janitorial',
    key: 'janitorial',
    status: 'Active',
    roleType: 'Employee',
    tag: ['BOH'],
    createdBy: 'System',
  },
];

//  Make List of roles you want to add as rolesListV(#)
export const rolesListV2: RoleList = [
  {
    roleName: 'Chef',
    key: 'chef',
    status: 'Active',
    roleType: 'Employee',
    tag: ['FOH'],
    createdBy: 'System',
  },
];
export const rolesListV3Accounts: RoleList = [
  {
    roleName: 'Accountant',
    key: 'accountant',
    status: 'Active',
    roleType: 'Employee',
    tag: ['FOH'],
    createdBy: 'System',
  },
];

// Permissions map for typing and easy reference. define it as const for typing the ids.
export const permissions = {
  [`${PermissionType.CREATE}`]: {
    id: 1,
    permissionType: 'Create',
    createdBy: 'System',
  },
  [`${PermissionType.EDIT}`]: {
    id: 2,
    permissionType: 'Edit',
    createdBy: 'System',
  },
  [`${PermissionType.DELETE}`]: {
    id: 3,
    permissionType: 'Delete',
    createdBy: 'System',
  },
  [`${PermissionType.READ}`]: {
    id: 4,
    permissionType: 'Read',
    createdBy: 'System',
  },
  [`${PermissionType.VISIBLE}`]: {
    id: 5,
    permissionType: 'Visible',
    createdBy: 'System',
  },
} as const;

// exporting an array out of map as was done before.
export const permissionList = Object.values(permissions);

// Apps map for typing and easy reference. Defined as const for typing the ids.
export const apps = {
  [`${AppTypes.MOM}`]: { id: 1, appName: 'MoM', key: 'mom', createdBy: 'System' },
  [`${AppTypes.POS}`]: { id: 2, appName: 'POS', key: 'pos', createdBy: 'System' },
  [`${AppTypes.MPOS}`]: { id: 3, appName: 'MPOS', key: 'mpos', createdBy: 'System' },
  [`${AppTypes.DASHBOARD}`]: { id: 4, appName: 'Web Dash', key: 'web-dash', createdBy: 'System' },
} as const;

// Exporting apps as an array for migrations
export const appList = Object.values(apps);

export const moduleList = [
  { id: 1, moduleName: 'My Restaurant', key: 'my-restaurant', createdBy: 'System' },
  { id: 2, moduleName: 'My Account', key: 'my-account', createdBy: 'System' },
  { id: 3, moduleName: 'Timecards', key: 'timecards', createdBy: 'System' },
  { id: 4, moduleName: 'Employee Availability', key: 'employee-availability', createdBy: 'System' },
  { id: 5, moduleName: 'Employee Time off', key: 'employee-time-off', createdBy: 'System' },
  { id: 6, moduleName: 'Employee Management', key: 'employee-management', createdBy: 'System' },
  { id: 7, moduleName: 'Roles & Permissions', key: 'roles-permissions', createdBy: 'System' },
  { id: 8, moduleName: 'Orders & Payments', key: 'orders-payments', createdBy: 'System' },
  { id: 9, moduleName: 'Hiring', key: 'hiring', createdBy: 'System' },
  { id: 10, moduleName: 'Restaurant Configurations', key: 'restaurant-configurations', createdBy: 'System' },
  { id: 11, moduleName: 'Shift Scheduler', key: 'shift-scheduler', createdBy: 'System' },
  { id: 12, moduleName: 'Shift Pool', key: 'shift-pool', createdBy: 'System' },
  { id: 13, moduleName: 'Reports', key: 'reports', createdBy: 'System' },
  { id: 14, moduleName: 'Clock In', key: 'clock-in', createdBy: 'System' },
  { id: 15, moduleName: 'Table Layout', key: 'table-layout', createdBy: 'System' },
  { id: 16, moduleName: 'Menu', key: 'menu', createdBy: 'System' },
  { id: 17, moduleName: 'Payments', key: 'payments', createdBy: 'System' },
  { id: 18, moduleName: 'Ticket', key: 'ticket', createdBy: 'System' },
  { id: 19, moduleName: 'Header', key: 'header', createdBy: 'System' },
  { id: 20, moduleName: 'Dashboard', key: 'dashboard', createdBy: 'System' },
  { id: 21, moduleName: 'Cashdrawer', key: 'cashdrawer', createdBy: 'System' },
  { id: 22, moduleName: 'Login', key: 'login', createdBy: 'System' },
  { id: 23, moduleName: 'Table Layout', key: 'table-layout', createdBy: 'System' },
  { id: 24, moduleName: 'Menu', key: 'menu', createdBy: 'System' },
  { id: 25, moduleName: 'Ticket', key: 'ticket', createdBy: 'System' },
  { id: 26, moduleName: 'Restaurant & Location', key: 'restaurant-&-location', createdBy: 'System' },
  { id: 27, moduleName: 'Menu Manager', key: 'menu-manager', createdBy: 'System' },
  { id: 28, moduleName: 'Marketing', key: 'marketing', createdBy: 'System' },
  { id: 29, moduleName: 'Inventory', key: 'inventory', createdBy: 'System' },
  { id: 30, moduleName: 'Accounting', key: 'accounting', createdBy: 'System' },
  { id: 31, moduleName: 'Employee Management', key: 'employee-management', createdBy: 'System' },
  { id: 35, moduleName: 'Task Manager', key: 'task-manager', createdBy: 'System' },
  { id: 36, moduleName: 'AIO Care', key: 'aio-care', createdBy: 'System' },
  { id: 37, moduleName: 'Docvault', key: 'docvault', createdBy: 'System' },
  { id: 38, moduleName: 'Dashboard', key: 'dashboard', createdBy: 'System' },
  { id: 39, moduleName: 'Lost & Found', key: 'lost-&-found', createdBy: 'System' },
  { id: 40, moduleName: 'Employee Payroll', key: 'employee-payroll', createdBy: 'System' },
  { id: 41, moduleName: 'Order Form', key: 'order-form', createdBy: 'System' },
  { id: 42, moduleName: 'Pay Management', key: 'pay-management', createdBy: 'System' },
  { id: 43, moduleName: 'Payments', key: 'payments', createdBy: 'System' },
  { id: 44, moduleName: 'Website', key: 'website', createdBy: 'System' },
  { id: 45, moduleName: 'Integrations', key: 'integrations', createdBy: 'System' },
  { id: 46, moduleName: 'Order Hub', key: 'order-hub', createdBy: 'System' },
];

// Make a map of modules you want to add. Map is for typing as easily referencing. Make new map as modulesV3. The id's are static and you need to start after the max id here.
export const modulesV2 = {
  'inventory-prepare-prep-list': {
    id: 47,
    moduleName: 'Inventory Prepare Prep List',
  },
  'inventory-cook-prep-list': {
    id: 48,
    moduleName: 'Inventory Cook Prep List',
  },
  'inventory-wastage-logs': {
    id: 49,
    moduleName: 'Inventory Wastage Logs',
  },
  'inventory-variance': {
    id: 50,
    moduleName: 'Inventory Variance',
  },
  'inventory-placed-orders': {
    id: 51,
    moduleName: 'Inventory Placed Orders',
  },
  'employee-payout': {
    id: 52,
    moduleName: 'Employee Payout',
  },
} as const;

const modulesV3 = {
  notifications: {
    moduleName: 'Notifications',
    id: 53,
  },
} as const;

//  Export an array for migration
export const moduleListV2 = Object.entries(modulesV2).map(([key, v]) => ({ key, createdBy: 'System', ...v }));

// Nugget Modules
export const modulesV4 = {
  nugget: {
    id: 60,
    moduleName: 'Nugget',
  },
} as const;

// Menu board
export const menuboardModule = {
  'menu-board': {
    id: 69,
    moduleName: 'Menu Board',
  },
} as const;

// Exported array for migration
export const moduleListV3 = Object.entries(modulesV3).map(([key, v]) => ({ key, createdBy: 'System', ...v }));
export const moduleListV4 = Object.entries(modulesV4).map(([key, v]) => ({ key, createdBy: 'System', ...v }));
export const menuboardModuleList = Object.entries(menuboardModule).map(([key, v]) => ({
  key,
  createdBy: 'System',
  ...v,
}));

export const featureList = [
  { id: 1, featureName: 'Business Information', key: 'business-information', createdBy: 'System' },
  { id: 2, featureName: 'Restaurant Information', key: 'restaurant-information', createdBy: 'System' },
  { id: 3, featureName: 'Bank Accounts', key: 'bank-accounts', createdBy: 'System' },
  { id: 4, featureName: 'Credit Card', key: 'credit-card', createdBy: 'System' },
  { id: 5, featureName: 'Recurring Payment Method', key: 'recurring-payment-method', createdBy: 'System' },
  { id: 6, featureName: 'Dashboard', key: 'dashboard', createdBy: 'System' },
  { id: 7, featureName: 'Overview', key: 'overview', createdBy: 'System' },
  { id: 8, featureName: 'Staff', key: 'staff', createdBy: 'System' },
  { id: 9, featureName: 'Office', key: 'office', createdBy: 'System' },
  { id: 10, featureName: 'Marketing', key: 'marketing', createdBy: 'System' },
  { id: 11, featureName: 'Your week', key: 'your-week', createdBy: 'System' },
  { id: 12, featureName: 'View Own Timecards', key: 'view-own-timecards', createdBy: 'System' },
  { id: 13, featureName: 'View other employees', key: 'view-other-employees', createdBy: 'System' },
  { id: 14, featureName: 'Export Timecards', key: 'export-timecards', createdBy: 'System' },
  { id: 15, featureName: 'Availability', key: 'availability', createdBy: 'System' },
  { id: 16, featureName: 'Time off request', key: 'time-off-request', createdBy: 'System' },
  { id: 17, featureName: 'Resend invite', key: 'resend-invite', createdBy: 'System' },
  { id: 18, featureName: 'Deactivate Employee', key: 'deactivate-employee', createdBy: 'System' },
  { id: 19, featureName: 'Re activate Employee', key: 're-activate-employee', createdBy: 'System' },
  { id: 20, featureName: 'Personal Information', key: 'personal-information', createdBy: 'System' },
  { id: 21, featureName: 'Assigned roles', key: 'assigned-roles', createdBy: 'System' },
  { id: 22, featureName: 'Location level access', key: 'location-level-access', createdBy: 'System' },
  { id: 23, featureName: 'Documents', key: 'documents', createdBy: 'System' },
  { id: 24, featureName: 'Roles & Permissions', key: 'roles-permissions', createdBy: 'System' },
  { id: 25, featureName: 'View order details', key: 'view-order-details', createdBy: 'System' },
  { id: 26, featureName: 'Refund', key: 'refund', createdBy: 'System' },
  { id: 27, featureName: 'Share job', key: 'share-job', createdBy: 'System' },
  { id: 28, featureName: 'General settings', key: 'general-settings', createdBy: 'System' },
  { id: 29, featureName: 'Device settings', key: 'device-settings', createdBy: 'System' },
  { id: 30, featureName: 'Online ordering', key: 'online-ordersing', createdBy: 'System' },

  { id: 31, featureName: 'Own shifts', key: 'own-shifts', createdBy: 'System' },
  { id: 32, featureName: 'Duplicate shift button', key: 'duplicate-shift-button', createdBy: 'System' },
  { id: 33, featureName: 'Release other employees shift', key: 'release-other-employees-shift', createdBy: 'System' },
  { id: 34, featureName: 'Release shifts', key: 'release-shifts', createdBy: 'System' },
  {
    id: 35,
    featureName: 'Assign to another employee button',
    key: 'assign-to-another-employee-button',
    createdBy: 'System',
  },

  { id: 36, featureName: 'Pool', key: 'pool', createdBy: 'System' },
  { id: 37, featureName: 'Pool view', key: 'pool-view', createdBy: 'System' },
  { id: 38, featureName: 'Approve requests', key: 'approve-requests', createdBy: 'System' },
  { id: 39, featureName: 'Net sales', key: 'net-sales', createdBy: 'System' },
  { id: 40, featureName: 'Labour cost', key: 'labour-cost', createdBy: 'System' },
  { id: 41, featureName: 'Comps & Voids', key: 'comps-voids', createdBy: 'System' },
  { id: 42, featureName: 'Top sellers', key: 'top-sellers', createdBy: 'System' },
  { id: 43, featureName: 'Break violations', key: 'break-violations', createdBy: 'System' },
  { id: 44, featureName: 'Clock in', key: 'clock-in', createdBy: 'System' },
  { id: 45, featureName: 'Login Without Clock In', key: 'login-without-clock-in', createdBy: 'System' },
  { id: 46, featureName: 'Device Status', key: 'device-status', createdBy: 'System' },
  { id: 47, featureName: 'Table', key: 'table', createdBy: 'System' },
  { id: 48, featureName: 'Table status', key: 'table-status', createdBy: 'System' },
  { id: 49, featureName: 'Switch Floors', key: 'switch-floors', createdBy: 'System' },
  { id: 50, featureName: 'View Seating Capacity', key: 'view-seating-capacity', createdBy: 'System' },
  { id: 51, featureName: 'Comp', key: 'comp', createdBy: 'System' },
  { id: 53, featureName: 'Update', key: 'update', createdBy: 'System' },
  { id: 54, featureName: 'Adjust', key: 'adjust', createdBy: 'System' },
  { id: 55, featureName: 'Service charges', key: 'service-charges', createdBy: 'System' },
  { id: 56, featureName: 'Custom Item', key: 'custom-item', createdBy: 'System' },
  { id: 57, featureName: 'Tax Exempt', key: 'tax-exempt', createdBy: 'System' },
  { id: 58, featureName: 'Change Table', key: 'change-table', createdBy: 'System' },
  { id: 59, featureName: 'Change Server', key: 'change-server', createdBy: 'System' },
  { id: 60, featureName: 'Void Order', key: 'void-order', createdBy: 'System' },
  { id: 61, featureName: 'Discounts', key: 'discounts', createdBy: 'System' },
  { id: 62, featureName: 'Settings hamburger', key: 'settings-hamburger', createdBy: 'System' },
  { id: 63, featureName: 'Orders Hub hamburger', key: 'orders-hub-hamburger', createdBy: 'System' },
  { id: 64, featureName: 'Restaurant type hamburger', key: 'restaurant-type-hamburger', createdBy: 'System' },
  { id: 65, featureName: 'Cashdrawer', key: 'cashdrawer', createdBy: 'System' },
  { id: 66, featureName: 'AIO help center', key: 'aio-help-center', createdBy: 'System' },
  { id: 67, featureName: 'My Day', key: 'my-day', createdBy: 'System' },
  { id: 68, featureName: 'Overview', key: 'overview', createdBy: 'System' },
  { id: 69, featureName: 'Z-report', key: 'z-report', createdBy: 'System' },
  { id: 70, featureName: 'Employee Attendance', key: 'employee-attendance', createdBy: 'System' },
  { id: 71, featureName: 'Other stations', key: 'other-stations', createdBy: 'System' },
  { id: 72, featureName: 'My station', key: 'my-station', createdBy: 'System' },
  { id: 73, featureName: 'Host drawer', key: 'host-drawer', createdBy: 'System' },
  { id: 74, featureName: 'Logs', key: 'logs', createdBy: 'System' },
  { id: 75, featureName: 'Adjust starting balance', key: 'adjust-starting-balance', createdBy: 'System' },
  { id: 76, featureName: 'Close drawer', key: 'close-drawer', createdBy: 'System' },
  { id: 77, featureName: 'Login', key: 'login', createdBy: 'System' },
  { id: 78, featureName: 'Other tables', key: 'other-tables', createdBy: 'System' },
  { id: 79, featureName: 'Void Items', key: 'void-items', createdBy: 'System' },
  { id: 80, featureName: 'Edit Service charge', key: 'edit-service-charge', createdBy: 'System' },
  { id: 81, featureName: 'Custom Item', key: 'custom-item', createdBy: 'System' },
  { id: 83, featureName: 'Restaurant', key: 'restaurant', createdBy: 'System' },
  { id: 84, featureName: 'Location', key: 'location', createdBy: 'System' },
  { id: 85, featureName: 'Re-assign', key: 're-assign', createdBy: 'System' },
  { id: 86, featureName: 'Can be assigned a task', key: 'can-be-assigned-a-task', createdBy: 'System' },
  { id: 87, featureName: 'P2P Chat', key: 'p2p-chat', createdBy: 'System' },
  { id: 88, featureName: 'Approve Button', key: 'approve-button', createdBy: 'System' },
  { id: 89, featureName: 'Custom category', key: 'custom-category', createdBy: 'System' },
  { id: 90, featureName: 'Menu', key: 'menu', createdBy: 'System' },
  { id: 91, featureName: 'Category', key: 'category', createdBy: 'System' },
  { id: 92, featureName: 'Item', key: 'Item', createdBy: 'System' },
  { id: 93, featureName: 'Modifier Group', key: 'modifier-group', createdBy: 'System' },
  { id: 94, featureName: 'Modifier', key: 'modifier', createdBy: 'System' },
  { id: 95, featureName: 'Modifier Option', key: 'modifier-option', createdBy: 'System' },
  { id: 96, featureName: 'Tags & Allergens', key: 'tags-&-allergens', createdBy: 'System' },
  { id: 97, featureName: 'Sales Tax', key: 'sales-tax', createdBy: 'System' },
  { id: 98, featureName: 'Comps', key: 'comps', createdBy: 'System' },
  { id: 99, featureName: 'Service Charge', key: 'service-charge', createdBy: 'System' },
  { id: 100, featureName: 'Guestbook', key: 'guestbook', createdBy: 'System' },
  { id: 101, featureName: 'Brandbook', key: 'brandbook', createdBy: 'System' },
  { id: 102, featureName: 'Deals', key: 'deals', createdBy: 'System' },
  { id: 103, featureName: 'Website', key: 'website', createdBy: 'System' },
  { id: 104, featureName: 'Spotlights', key: 'spotlights', createdBy: 'System' },
  { id: 105, featureName: 'Campaigns', key: 'campaigns', createdBy: 'System' },
  { id: 106, featureName: 'Journeys', key: 'journeys', createdBy: 'System' },
  { id: 107, featureName: 'Loyalty', key: 'loyalty', createdBy: 'System' },
  { id: 108, featureName: 'Dashboard', key: 'dashboard', createdBy: 'System' },
  { id: 109, featureName: 'Gift Cards', key: 'gift-cards', createdBy: 'System' },
  { id: 110, featureName: 'My Account', key: 'my-account', createdBy: 'System' },
  { id: 111, featureName: 'Edit time entries', key: 'edit-time-entries', createdBy: 'System' },
  { id: 112, featureName: 'View other employees', key: 'view-other-employees', createdBy: 'System' },
  { id: 113, featureName: 'Approve requests', key: 'approve-requests', createdBy: 'System' },
  { id: 114, featureName: 'Request Tab', key: 'request-tab', createdBy: 'System' },
  { id: 115, featureName: 'Processed Tab', key: 'processed-tab', createdBy: 'System' },
  { id: 116, featureName: 'My own tab', key: 'my-own-tab', createdBy: 'System' },

  { id: 117, featureName: 'Shifts', key: 'shifts', createdBy: 'System' },

  {
    id: 118,
    featureName: 'Release Manager approval required',
    key: 'release-manager-approval-required',
    createdBy: 'System',
  },
  { id: 119, featureName: 'Bid on open shifts', key: 'bid-on-open-shifts', createdBy: 'System' },

  { id: 120, featureName: 'Employees', key: 'employees', createdBy: 'System' },
  { id: 121, featureName: 'Details Button', key: 'details-button', createdBy: 'System' },
  { id: 122, featureName: 'Tasks', key: 'tasks', createdBy: 'System' },
  { id: 123, featureName: 'Files', key: 'files', createdBy: 'System' },
  { id: 124, featureName: 'Folders', key: 'folders', createdBy: 'System' },
  { id: 125, featureName: 'Lost Items', key: 'lost-items', createdBy: 'System' },
  { id: 126, featureName: 'Found Items', key: 'found-items', createdBy: 'System' },
  { id: 127, featureName: 'Mark as retrieved', key: 'mark-as-retrieved', createdBy: 'System' },
  { id: 128, featureName: 'Pay schedules', key: 'pay-schedules', createdBy: 'System' },
  { id: 129, featureName: 'Payroll', key: 'payroll', createdBy: 'System' },
  { id: 130, featureName: 'Order forms', key: 'order-forms', createdBy: 'System' },
  { id: 131, featureName: 'View others pay stubs', key: 'view-others-pay-stubs', createdBy: 'System' },
  { id: 132, featureName: 'View own paystubs', key: 'view-own-paystubs', createdBy: 'System' },
  { id: 133, featureName: 'Clock In', key: 'clock-in', createdBy: 'System' },
  { id: 134, featureName: 'Tenders', key: 'tenders', createdBy: 'System' },
  { id: 135, featureName: 'Website templates', key: 'website-templates', createdBy: 'System' },
  { id: 136, featureName: 'Website builder', key: 'website-builder', createdBy: 'System' },
  { id: 137, featureName: 'Website seo', key: 'website-seo', createdBy: 'System' },
  { id: 138, featureName: 'Website announcements', key: 'website-announcements', createdBy: 'System' },
  { id: 139, featureName: 'Guest Segments', key: 'guest-segments', createdBy: 'System' },
  { id: 140, featureName: 'Guest Spend', key: 'guest-spend', createdBy: 'System' },
  { id: 141, featureName: 'Integrations', key: 'integration', createdBy: 'System' },
  { id: 142, featureName: 'Review Management', key: 'review-management', createdBy: 'System' },
  { id: 146, featureName: 'Cash Drawer', key: 'cash-drawer', createdBy: 'System' },
  { id: 147, featureName: 'Ticket', key: 'ticket', createdBy: 'System' },

  { id: 148, featureName: 'Ingredients', key: 'ingredients', createdBy: 'System' },
  { id: 149, featureName: 'Orders', key: 'orders', createdBy: 'System' },
  { id: 150, featureName: 'Recipes', key: 'recipes', createdBy: 'System' },
  { id: 151, featureName: 'invoices', key: 'invoices', createdBy: 'System' },
  { id: 152, featureName: 'Storage Areas', key: 'storage-areas', createdBy: 'System' },
  { id: 153, featureName: 'Vendors', key: 'vendors', createdBy: 'System' },
  { id: 154, featureName: 'Non Ingredients', key: 'non-ingredients', createdBy: 'System' },
];

// Make a map of features you want to add. Map is for typing as easily referencing. Make new map as featuresV3. The id's are static and you need to start after the max id here.
// The key in map is to be inserted as "key" in features table
export const featuresV2 = {
  'inventory-prepare-prep-list': {
    id: 155,
    featureName: 'Inventory Prepare Prep List',
  },
  'inventory-cook-prep-list': {
    id: 156,
    featureName: 'Inventory Cook Prep List',
  },
  'inventory-wastage-logs': {
    id: 157,
    featureName: 'Inventory Wastage Logs',
  },
  'inventory-variance': {
    id: 158,
    featureName: 'Inventory Variance',
  },
  'inventory-placed-orders': {
    id: 159,
    featureName: 'Inventory Placed Orders',
  },
  'employee-payout': {
    id: 160,
    featureName: 'Employee Payout',
  },
} as const;

export const featuresV3 = {
  // accounting features
  'chart-of-accounts': { id: 161, featureName: 'Chart of Accounts', createdBy: 'System' },

  'bill-payments': { id: 162, featureName: 'Bill Payments', createdBy: 'System' },

  'journal-entry': { id: 163, featureName: 'Journal Entry', createdBy: 'System' },

  reconciliation: { id: 164, featureName: 'Reconciliation', createdBy: 'System' },

  'sales-controller': { id: 165, featureName: 'Sales Controller', createdBy: 'System' },
} as const;

// export an array for migration
export const featureListV2 = Object.entries(featuresV2).map(([key, v]) => ({ key, ...v, createdBy: 'System' }));
export const featureListV3Accounts = Object.entries(featuresV3).map(([key, v]) => ({ key, ...v, createdBy: 'System' }));

export const featureListV3 = Object.entries(featuresV3).map(([key, v]) => ({ key, ...v, createdBy: 'System' }));

const featuresV4 = {
  notifications: {
    id: 166,
    featureName: 'Notifications',
  },
  'inventory-overview': {
    id: 167,
    featureName: 'Inventory Overview',
  },
  'aio-care-overview': {
    id: 168,
    featureName: 'Aio Care Overview',
  },
} as const;

export const featureListV4 = Object.entries(featuresV4).map(([key, v]) => ({ key, ...v, createdBy: 'System' }));

const featuresV5 = {
  'featured-menu': {
    id: 175,
    featureName: 'Featured Menu',
  },
  'featured-ads': {
    id: 176,
    featureName: 'Featured Ads',
  },
} as const;

export const featureListV5 = Object.entries(featuresV5).map(([key, v]) => ({ key, ...v, createdBy: 'System' }));

// Menu Board
const menuboardFeauters = {
  playlists: {
    id: 203,
    featureName: 'Playlists',
  },
  screens: {
    id: 198,
    featureName: 'Screens',
  },
} as const;

export const menuboardFeautersList = Object.entries(menuboardFeauters).map(([key, v]) => ({
  key,
  ...v,
  createdBy: 'System',
}));

// Settings Pos
const settingsFeature = {
  pos: {
    id: 215,
    featureName: 'POS',
  },
};

export const settingsFeatureList = Object.entries(settingsFeature).map(([key, v]) => ({
  key,
  ...v,
  createdBy: 'System',
}));

export const moduleFeaturesV5: {
  moduleId: number;
  featureId: (typeof settingsFeatureList)[number]['id'];
}[] = [{ moduleId: 65, featureId: settingsFeature['pos'].id }];

export const appModules = [
  { appId: 1, moduleId: 1 },
  { appId: 1, moduleId: 2 },
  { appId: 1, moduleId: 3 },
  { appId: 1, moduleId: 4 },
  { appId: 1, moduleId: 5 },
  { appId: 1, moduleId: 6 },
  { appId: 1, moduleId: 7 },
  { appId: 1, moduleId: 8 },
  { appId: 1, moduleId: 9 },
  { appId: 1, moduleId: 10 },
  { appId: 1, moduleId: 11 },
  { appId: 1, moduleId: 12 },
  { appId: 1, moduleId: 13 },
  { appId: 1, moduleId: 35 },
  { appId: 1, moduleId: 36 },
  { appId: 1, moduleId: 37 },
  { appId: 1, moduleId: 38 },
  { appId: 1, moduleId: 39 },
  { appId: 1, moduleId: 40 },
  { appId: 1, moduleId: 41 },
  { appId: 1, moduleId: 42 },

  { appId: 2, moduleId: 14 },
  { appId: 2, moduleId: 15 },
  { appId: 2, moduleId: 16 },
  { appId: 2, moduleId: 18 },
  { appId: 2, moduleId: 19 },
  { appId: 2, moduleId: 20 },
  { appId: 2, moduleId: 21 },
  { appId: 2, moduleId: 43 },

  { appId: 3, moduleId: 14 }, // MPOS - CLOCK-IN
  { appId: 3, moduleId: 22 },
  { appId: 3, moduleId: 23 },
  { appId: 3, moduleId: 24 },
  { appId: 3, moduleId: 25 },
  { appId: 3, moduleId: 43 }, // MPOS - Payments
  { appId: 4, moduleId: 26 },
  { appId: 4, moduleId: 27 },
  { appId: 4, moduleId: 17 },
  { appId: 4, moduleId: 28 },
  { appId: 4, moduleId: 29 },
  { appId: 4, moduleId: 30 }, //Accounts
  { appId: 4, moduleId: 31 },
  { appId: 4, moduleId: 44 },
  { appId: 4, moduleId: 45 },
  { appId: 2, moduleId: 46 },
  { appId: 4, moduleId: 7 },
  { appId: 4, moduleId: 2 },
];

// This is mapping of app and module. The type is to make sure that the id's passed exist in the related module and app lists. Typescript works here. If adding new mapping, create appModuleV(#)
export const appModulesV2: { moduleId: (typeof moduleListV2)[number]['id']; appId: (typeof appList)[number]['id'] }[] =
  [
    { appId: apps.mom.id, moduleId: modulesV2['inventory-prepare-prep-list'].id },
    { appId: apps.mom.id, moduleId: modulesV2['inventory-cook-prep-list'].id },
    { appId: apps.mom.id, moduleId: modulesV2['inventory-wastage-logs'].id },
    { appId: apps.mom.id, moduleId: modulesV2['inventory-variance'].id },
    { appId: apps.mom.id, moduleId: modulesV2['inventory-placed-orders'].id },
    { appId: apps.mom.id, moduleId: modulesV2['employee-payout'].id },
  ];

export const appModulesV3: { moduleId: (typeof moduleListV3)[number]['id']; appId: (typeof appList)[number]['id'] }[] =
  [{ appId: apps.mom.id, moduleId: modulesV3['notifications'].id }];

export const appModulesV4: { moduleId: (typeof moduleListV4)[number]['id']; appId: (typeof appList)[number]['id'] }[] =
  [{ appId: apps.dashboard.id, moduleId: modulesV4['nugget'].id }];

export const menuboardAppModule: {
  moduleId: (typeof menuboardModuleList)[number]['id'];
  appId: (typeof appList)[number]['id'];
}[] = [{ appId: apps.dashboard.id, moduleId: menuboardModule['menu-board'].id }];

export const moduleFeatures = [
  { moduleId: 1, featureId: 1 },
  { moduleId: 1, featureId: 2 },
  { moduleId: 1, featureId: 3 },
  { moduleId: 1, featureId: 4 },
  { moduleId: 1, featureId: 5 },
  { moduleId: 38, featureId: 7 },
  { moduleId: 38, featureId: 8 },
  { moduleId: 38, featureId: 9 },
  { moduleId: 38, featureId: 10 },
  { moduleId: 38, featureId: 11 },
  { moduleId: 3, featureId: 12 },
  { moduleId: 3, featureId: 13 },
  { moduleId: 3, featureId: 14 },
  { moduleId: 4, featureId: 15 },
  { moduleId: 5, featureId: 16 },
  { moduleId: 6, featureId: 17 },
  { moduleId: 6, featureId: 18 },
  { moduleId: 6, featureId: 19 },
  { moduleId: 6, featureId: 20 },
  { moduleId: 6, featureId: 21 },
  { moduleId: 6, featureId: 22 },
  { moduleId: 6, featureId: 23 },
  { moduleId: 8, featureId: 25 },
  { moduleId: 8, featureId: 26 },
  { moduleId: 9, featureId: 27 },
  { moduleId: 10, featureId: 28 },
  { moduleId: 10, featureId: 29 },
  { moduleId: 10, featureId: 30 },
  { moduleId: 11, featureId: 31 },
  { moduleId: 11, featureId: 32 },
  { moduleId: 11, featureId: 33 },
  { moduleId: 11, featureId: 34 },
  { moduleId: 11, featureId: 35 },
  { moduleId: 12, featureId: 36 },
  { moduleId: 12, featureId: 37 },
  { moduleId: 12, featureId: 38 },
  { moduleId: 13, featureId: 39 },
  { moduleId: 13, featureId: 40 },
  { moduleId: 13, featureId: 41 },
  { moduleId: 13, featureId: 42 },
  { moduleId: 13, featureId: 43 },
  { moduleId: 14, featureId: 45 },
  { moduleId: 14, featureId: 46 },
  { moduleId: 15, featureId: 47 },
  { moduleId: 15, featureId: 48 },
  { moduleId: 15, featureId: 49 },
  { moduleId: 15, featureId: 50 },
  { moduleId: 16, featureId: 51 },
  { moduleId: 43, featureId: 26 },
  { moduleId: 43, featureId: 53 },
  { moduleId: 43, featureId: 54 },
  { moduleId: 18, featureId: 55 },
  { moduleId: 18, featureId: 56 },
  { moduleId: 18, featureId: 57 },
  { moduleId: 18, featureId: 58 },
  { moduleId: 18, featureId: 59 },
  { moduleId: 18, featureId: 60 },
  { moduleId: 18, featureId: 61 },
  { moduleId: 19, featureId: 62 },
  { moduleId: 19, featureId: 63 },
  { moduleId: 19, featureId: 64 },
  { moduleId: 19, featureId: 65 },
  { moduleId: 19, featureId: 66 },
  { moduleId: 20, featureId: 67 },
  { moduleId: 20, featureId: 68 },
  { moduleId: 20, featureId: 69 },
  { moduleId: 20, featureId: 70 },
  { moduleId: 21, featureId: 71 },
  { moduleId: 21, featureId: 72 },
  { moduleId: 21, featureId: 73 },
  { moduleId: 21, featureId: 74 },
  { moduleId: 21, featureId: 75 },
  { moduleId: 21, featureId: 76 },
  { moduleId: 22, featureId: 77 },
  { moduleId: 23, featureId: 78 },
  { moduleId: 24, featureId: 51 },
  { moduleId: 24, featureId: 79 },
  { moduleId: 24, featureId: 80 },
  { moduleId: 25, featureId: 81 },
  { moduleId: 25, featureId: 57 },
  { moduleId: 25, featureId: 58 },
  { moduleId: 25, featureId: 59 },
  { moduleId: 25, featureId: 60 },
  { moduleId: 25, featureId: 61 },
  { moduleId: 26, featureId: 83 },
  { moduleId: 26, featureId: 84 },
  { moduleId: 35, featureId: 85 },
  { moduleId: 35, featureId: 86 },
  { moduleId: 36, featureId: 87 },
  { moduleId: 36, featureId: 88 },
  { moduleId: 37, featureId: 89 },
  { moduleId: 27, featureId: 90 },
  { moduleId: 27, featureId: 91 },
  { moduleId: 27, featureId: 92 },
  { moduleId: 27, featureId: 93 },
  { moduleId: 27, featureId: 94 },
  { moduleId: 27, featureId: 95 },
  { moduleId: 27, featureId: 96 },
  { moduleId: 17, featureId: 97 },
  { moduleId: 17, featureId: 98 },
  { moduleId: 17, featureId: 99 },
  { moduleId: 17, featureId: 134 },
  { moduleId: 28, featureId: 100 },
  { moduleId: 28, featureId: 101 },
  { moduleId: 28, featureId: 102 },
  { moduleId: 28, featureId: 103 },
  { moduleId: 28, featureId: 104 },
  { moduleId: 28, featureId: 105 },
  { moduleId: 28, featureId: 106 },
  { moduleId: 28, featureId: 107 },
  { moduleId: 28, featureId: 108 },
  { moduleId: 28, featureId: 109 },
  { moduleId: 28, featureId: 139 },
  { moduleId: 28, featureId: 140 },
  { moduleId: 28, featureId: 142 },
  { moduleId: 2, featureId: 110 },
  { moduleId: 3, featureId: 111 },
  { moduleId: 4, featureId: 112 },
  { moduleId: 5, featureId: 113 },
  { moduleId: 5, featureId: 114 },
  { moduleId: 5, featureId: 115 },
  { moduleId: 5, featureId: 116 },
  { moduleId: 7, featureId: 24 },
  { moduleId: 11, featureId: 117 },
  { moduleId: 11, featureId: 118 },
  { moduleId: 11, featureId: 119 },
  { moduleId: 6, featureId: 120 },
  { moduleId: 6, featureId: 121 },
  { moduleId: 35, featureId: 122 },
  { moduleId: 37, featureId: 123 },
  { moduleId: 37, featureId: 124 },
  { moduleId: 39, featureId: 125 },
  { moduleId: 39, featureId: 126 },
  { moduleId: 39, featureId: 127 },
  { moduleId: 40, featureId: 128 },
  { moduleId: 40, featureId: 129 },
  { moduleId: 41, featureId: 130 },
  { moduleId: 42, featureId: 131 },
  { moduleId: 42, featureId: 132 },
  { moduleId: 14, featureId: 133 },
  { moduleId: 43, featureId: 134 },
  { moduleId: 44, featureId: 135 },
  { moduleId: 44, featureId: 136 },
  { moduleId: 44, featureId: 137 },
  { moduleId: 44, featureId: 138 },
  { moduleId: 17, featureId: 146 },
  { moduleId: 46, featureId: 147 },
  { moduleId: 29, featureId: 148 },
  { moduleId: 29, featureId: 149 },
  { moduleId: 29, featureId: 150 },
  { moduleId: 29, featureId: 151 },
  { moduleId: 29, featureId: 152 },
  { moduleId: 29, featureId: 153 },
  { moduleId: 29, featureId: 154 },
  // { moduleId: 30, featureId: 155 },
  // { moduleId: 30, featureId: 156 },
  // { moduleId: 30, featureId: 157 },
  // { moduleId: 30, featureId: 158 },
  // { moduleId: 30, featureId: 159 },
];

// export const moduleFeaturesV2 = [];
export const moduleFeaturesV3Accounts = [
  { moduleId: 30, featureId: 161 },
  { moduleId: 30, featureId: 162 },
  { moduleId: 30, featureId: 163 },
  { moduleId: 30, featureId: 164 },
  { moduleId: 30, featureId: 165 },
];
// This is mapping of module and feature. The type is to make sure that the id's passed exist in the related module and feature lists. Typescript works here. If adding new mapping, create moduleFeatures(#)
export const moduleFeaturesV2: {
  moduleId: (typeof moduleListV2)[number]['id'];
  featureId: (typeof featureListV2)[number]['id'];
}[] = [
  { moduleId: modulesV2['employee-payout'].id, featureId: featuresV2['employee-payout'].id },
  { moduleId: modulesV2['inventory-cook-prep-list'].id, featureId: featuresV2['inventory-cook-prep-list'].id },
  { moduleId: modulesV2['inventory-prepare-prep-list'].id, featureId: featuresV2['inventory-prepare-prep-list'].id },
  { moduleId: modulesV2['inventory-placed-orders'].id, featureId: featuresV2['inventory-placed-orders'].id },
  { moduleId: modulesV2['inventory-variance'].id, featureId: featuresV2['inventory-variance'].id },
  { moduleId: modulesV2['inventory-wastage-logs'].id, featureId: featuresV2['inventory-wastage-logs'].id },
];

export const moduleFeaturesV3: {
  moduleId: (typeof moduleListV4)[number]['id'];
  featureId: (typeof featureListV5)[number]['id'];
}[] = [
  { moduleId: modulesV4['nugget'].id, featureId: featuresV5['featured-menu'].id }, //NuggetConfiguration - featured-menu
  { moduleId: modulesV4['nugget'].id, featureId: featuresV5['featured-ads'].id }, //NuggetConfiguration - featured-ads
];

export const moduleFeaturesV4: {
  moduleId: number;
  featureId: (typeof featureListV4)[number]['id'];
}[] = [
  { moduleId: 38, featureId: featuresV4['aio-care-overview'].id },
  { moduleId: 38, featureId: featuresV4['inventory-overview'].id },
  { moduleId: modulesV3.notifications.id, featureId: featuresV4['notifications'].id },
];

export const menuboardModuleFeatures: {
  moduleId: number;
  featureId: (typeof menuboardFeautersList)[number]['id'];
}[] = [
  { moduleId: 69, featureId: menuboardFeauters['playlists'].id },
  { moduleId: 69, featureId: menuboardFeauters['screens'].id },
];

export const userPermissionList = [
  ...defaultOwnerPermission,
  ...defaultManagerPermissions,
  ...defaultServerPermission,
  ...defaultGmPermissions,
  ...defaultBusserPermission,
  ...defaultCookPermission,
  ...defaultBartenderPermission,
  ...defaultShiftAssistanceManager,
  ...defaultJanitorialPermission,
  ...defaultDeliveryServiceDriver,
  ...defaultLineCook,
  ...defaultDishWasherPermission,
  ...defaultCashierPermissions,
];

// This is the list of permissions that we need to add. The types work here and does the following. 1) Makes sure the ids entered exist in the related lists.
// 2) Provide intellisense for "key" from userPermissionContent. 3) Provide intellisense and type checking for other fields.
export const userPermissionListV2: {
  roleKey: `${UserRoleType}`;
  userId: string | null;
  permissionId: (typeof permissionList)[number]['id'];
  appId: (typeof appList)[number]['id'];
  moduleId: (typeof moduleListV2)[number]['id'] | null | number;
  featureId: (typeof featureListV2)[number]['id'] | null | number;
  key:
    | (typeof userPermissionContent.app)[keyof typeof userPermissionContent.app]
    | (typeof userPermissionContent.feature)[keyof typeof userPermissionContent.feature]
    | (typeof userPermissionContent.module)[keyof typeof userPermissionContent.module];
  isGranted: boolean;
  isApprovalNeeded: boolean;
  permissionLevel: `${PermissionLevel}`;
  type: 'Role' | 'User';
  status: `${RecordStatus}`;
  createdBy: 'System';
}[] = [
  //  As chef is a new role inserted with current migration so we have to give access to mom
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: null,
    featureId: null,
    key: 'mom-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: modulesV2['inventory-prepare-prep-list'].id,
    featureId: null,
    key: 'inventory-prepare-prep-list-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: modulesV2['inventory-prepare-prep-list'].id,
    featureId: featuresV2['inventory-prepare-prep-list'].id,
    key: 'inventory-prepare-prep-list-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: modulesV2['inventory-prepare-prep-list'].id,
    featureId: null,
    key: 'inventory-prepare-prep-list-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: permissions['Visible'].id,
    appId: apps['mom'].id,
    moduleId: modulesV2['inventory-prepare-prep-list'].id,
    featureId: featuresV2['inventory-prepare-prep-list'].id,
    key: 'inventory-prepare-prep-list-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: modulesV2['inventory-prepare-prep-list'].id,
    featureId: null,
    key: 'inventory-prepare-prep-list-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions['Visible'].id,
    appId: apps['mom'].id,
    moduleId: modulesV2['inventory-prepare-prep-list'].id,
    featureId: featuresV2['inventory-prepare-prep-list'].id,
    key: 'inventory-prepare-prep-list-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: modulesV2['inventory-prepare-prep-list'].id,
    featureId: null,
    key: 'inventory-prepare-prep-list-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions['Visible'].id,
    appId: apps['mom'].id,
    moduleId: modulesV2['inventory-prepare-prep-list'].id,
    featureId: featuresV2['inventory-prepare-prep-list'].id,
    key: 'inventory-prepare-prep-list-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'cook',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: modulesV2['inventory-cook-prep-list'].id, // Inventory Cook Prep List
    featureId: null,
    key: 'inventory-cook-prep-list-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'cook',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: modulesV2['inventory-cook-prep-list'].id, // Inventory Cook Prep List
    featureId: featuresV2['inventory-cook-prep-list'].id,
    key: 'inventory-cook-prep-list-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: modulesV2['inventory-cook-prep-list'].id, // Inventory Cook Prep List
    featureId: null,
    key: 'inventory-cook-prep-list-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: modulesV2['inventory-cook-prep-list'].id, // Inventory Cook Prep List
    featureId: featuresV2['inventory-cook-prep-list'].id,
    key: 'inventory-cook-prep-list-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: modulesV2['inventory-cook-prep-list'].id, // Inventory Cook Prep List
    featureId: null,
    key: 'inventory-cook-prep-list-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: modulesV2['inventory-cook-prep-list'].id, // Inventory Cook Prep List
    featureId: featuresV2['inventory-cook-prep-list'].id,
    key: 'inventory-cook-prep-list-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: modulesV2['inventory-wastage-logs'].id, // Inventory Wastage Logs
    featureId: null,
    key: 'inventory-wastage-logs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: modulesV2['inventory-wastage-logs'].id, // Inventory Wastage Logs
    featureId: featuresV2['inventory-wastage-logs'].id,
    key: 'inventory-wastage-logs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: modulesV2['inventory-wastage-logs'].id, // Inventory Wastage Logs
    featureId: null,
    key: 'inventory-wastage-logs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: modulesV2['inventory-wastage-logs'].id, // Inventory Wastage Logs
    featureId: featuresV2['inventory-wastage-logs'].id,
    key: 'inventory-wastage-logs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-wastage-logs'].id, // Inventory Wastage Logs
    featureId: null,
    key: 'inventory-wastage-logs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-wastage-logs'].id, // Inventory Wastage Logs
    featureId: featuresV2['inventory-wastage-logs'].id,
    key: 'inventory-wastage-logs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-wastage-logs'].id, // Inventory Wastage Logs
    featureId: null,
    key: 'inventory-wastage-logs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-wastage-logs'].id, // Inventory Wastage Logs
    featureId: featuresV2['inventory-wastage-logs'].id,
    key: 'inventory-wastage-logs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-variance'].id, // Inventory Variance
    featureId: null,
    key: 'inventory-variance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-variance'].id, // Inventory Variance
    featureId: featuresV2['inventory-variance'].id,
    key: 'inventory-variance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-variance'].id, // Inventory Variance
    featureId: null,
    key: 'inventory-variance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-variance'].id, // Inventory Variance
    featureId: featuresV2['inventory-variance'].id,
    key: 'inventory-variance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-variance'].id, // Inventory Variance
    featureId: null,
    key: 'inventory-variance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-variance'].id, // Inventory Variance
    featureId: featuresV2['inventory-variance'].id,
    key: 'inventory-variance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-variance'].id, // Inventory Variance
    featureId: null,
    key: 'inventory-variance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-variance'].id, // Inventory Variance
    featureId: featuresV2['inventory-variance'].id,
    key: 'inventory-variance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-placed-orders'].id, // Inventory Placed Orders
    featureId: null,
    key: 'inventory-placed-orders-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-placed-orders'].id, // Inventory Placed Orders
    featureId: featuresV2['inventory-placed-orders'].id,
    key: 'inventory-placed-orders-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-placed-orders'].id, // Inventory Placed Orders
    featureId: null,
    key: 'inventory-placed-orders-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-placed-orders'].id, // Inventory Placed Orders
    featureId: featuresV2['inventory-placed-orders'].id,
    key: 'inventory-placed-orders-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-placed-orders'].id, // Inventory Placed Orders
    featureId: null,
    key: 'inventory-placed-orders-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-placed-orders'].id, // Inventory Placed Orders
    featureId: featuresV2['inventory-placed-orders'].id,
    key: 'inventory-placed-orders-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-placed-orders'].id, // Inventory Placed Orders
    featureId: null,
    key: 'inventory-placed-orders-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['inventory-placed-orders'].id, // Inventory Placed Orders
    featureId: featuresV2['inventory-placed-orders'].id,
    key: 'inventory-placed-orders-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // Employee Payout
  {
    roleKey: 'super-admin',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: null,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'super-admin',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: featuresV2['employee-payout'].id,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'operation',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: null,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'operation',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: featuresV2['employee-payout'].id,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  // {
  //   roleKey: 'aio-buddy',
  //   userId: null,
  //   permissionId: permissions.Visible.id, // view
  //   appId: apps.mom.id, // mom
  //   moduleId: modulesV2['employee-payout'].id,
  //   featureId: null,
  //   isApprovalNeeded: false,
  //   permissionLevel: 'Module',
  //   type: 'Role',
  //   status: 'Active',
  //   createdBy: 'System',
  // },
  // {
  //   roleKey: 'aio-buddy',
  //   userId: null,
  //   permissionId: permissions.Visible.id, // view
  //   appId: apps.mom.id, // mom
  //   moduleId: modulesV2['employee-payout'].id,
  //   featureId: featuresV2['employee-payout'].id,
  //   key: 'employee-payout-visible',
  //   isGranted: true,
  //   isApprovalNeeded: false,
  //   permissionLevel: 'Feature',
  //   type: 'Role',
  //   status: 'Active',
  //   createdBy: 'System',
  // },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: null,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: featuresV2['employee-payout'].id,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: null,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: featuresV2['employee-payout'].id,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'server',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: null,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'server',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: featuresV2['employee-payout'].id,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'cook',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: null,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'cook',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: featuresV2['employee-payout'].id,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'bartender',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: null,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'bartender',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: featuresV2['employee-payout'].id,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'cashier',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: null,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'cashier',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: featuresV2['employee-payout'].id,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'busser',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: null,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'busser',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: featuresV2['employee-payout'].id,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'delivery-service-driver',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: null,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'delivery-service-driver',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: featuresV2['employee-payout'].id,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'shift-or-assistant-manager',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: null,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'shift-or-assistant-manager',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: featuresV2['employee-payout'].id,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'barback',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: null,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'barback',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: featuresV2['employee-payout'].id,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: null,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: featuresV2['employee-payout'].id,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: null,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'dish-washer',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: featuresV2['employee-payout'].id,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: null,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'janitorial',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: featuresV2['employee-payout'].id,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: null,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: featuresV2['employee-payout'].id,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'line-cook',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: null,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'line-cook',
    userId: null,
    permissionId: permissions.Visible.id, // view
    appId: apps.mom.id, // mom
    moduleId: modulesV2['employee-payout'].id,
    featureId: featuresV2['employee-payout'].id,
    key: 'employee-payout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.pos.id,
    moduleId: 20,
    featureId: 70,
    key: 'employee-attendance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];

export const serverPermissionsAdded: {
  roleKey: `${UserRoleType}`;
  userId: string | null;
  permissionId: (typeof permissionList)[number]['id'];
  appId: (typeof appList)[number]['id'];
  moduleId: (typeof moduleListV2)[number]['id'] | null | number;
  featureId: (typeof featureListV2)[number]['id'] | null | number;
  key: string;
  isGranted: boolean;
  isApprovalNeeded: boolean;
  permissionLevel: `${PermissionLevel}`;
  type: 'Role' | 'User';
  status: `${RecordStatus}`;
  createdBy: 'System';
}[] = [
  {
    roleKey: 'server',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.pos.id,
    moduleId: 43,
    featureId: 26,
    key: 'refund-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'server',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.pos.id,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'server',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.pos.id,
    moduleId: 43,
    featureId: 54,
    key: 'adjust-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'server',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.pos.id,
    moduleId: 43,
    featureId: 134,
    key: 'tenders-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.pos.id,
    moduleId: 43,
    featureId: 26,
    key: 'refund-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.pos.id,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.pos.id,
    moduleId: 43,
    featureId: 54,
    key: 'adjust-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.pos.id,
    moduleId: 43,
    featureId: 134,
    key: 'tenders-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  //
  {
    roleKey: 'server',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mpos.id,
    moduleId: 43,
    featureId: 26,
    key: 'refund-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'server',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mpos.id,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'server',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mpos.id,
    moduleId: 43,
    featureId: 54,
    key: 'adjust-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'server',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mpos.id,
    moduleId: 43,
    featureId: 134,
    key: 'tenders-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mpos.id,
    moduleId: 43,
    featureId: 26,
    key: 'refund-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mpos.id,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mpos.id,
    moduleId: 43,
    featureId: 54,
    key: 'adjust-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mpos.id,
    moduleId: 43,
    featureId: 134,
    key: 'tenders-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];

export const userPermissionListV4: {
  roleKey: `${UserRoleType}`;
  userId: string | null;
  permissionId: (typeof permissionList)[number]['id'];
  appId: (typeof appList)[number]['id'];
  moduleId: number;
  featureId: (typeof featureListV4)[number]['id'] | null;
  key: string;
  isGranted: boolean;
  isApprovalNeeded: boolean;
  permissionLevel: `${PermissionLevel}`;
  type: 'Role' | 'User';
  status: `${RecordStatus}`;
  createdBy: 'System';
}[] = [
  {
    roleKey: 'chef',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.mom.id,
    moduleId: 38,
    featureId: null,
    key: 'dashboard-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: 38,
    featureId: featuresV4['inventory-overview'].id,
    key: userPermissionContent.feature.inventory_overview_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: 38,
    featureId: featuresV4['inventory-overview'].id,
    key: userPermissionContent.feature.inventory_overview_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'chef',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: 38,
    featureId: featuresV4['inventory-overview'].id,
    key: userPermissionContent.feature.inventory_overview_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'cook',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: 38,
    featureId: featuresV4['inventory-overview'].id,
    key: userPermissionContent.feature.inventory_overview_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: 38,
    featureId: featuresV4['inventory-overview'].id,
    key: userPermissionContent.feature.inventory_overview_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: 38,
    featureId: featuresV4['aio-care-overview'].id,
    key: userPermissionContent.feature.aio_care_chat_overview_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: 38,
    featureId: featuresV4['aio-care-overview'].id,
    key: userPermissionContent.feature.aio_care_chat_overview_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions['Visible'].id, // view
    appId: apps['mom'].id, // mom
    moduleId: 38,
    featureId: featuresV4['aio-care-overview'].id,
    key: userPermissionContent.feature.aio_care_chat_overview_visible,
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];

export const newPermissionEmployeeAndDashboard = [
  {
    userId: null,
    permissionId: 5,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: null,
    key: 'employee-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 5,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 17,
    key: 'resend-invite-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 5,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 18,
    key: 'deactivate-employee-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 5,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 19,
    key: 're-activate-employee-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 5,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 4,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 2,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 5,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 1,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 4,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 2,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 3,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 5,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 1,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 4,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 2,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 3,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 5,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 23,
    key: 'documents-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 4,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 23,
    key: 'documents-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 5,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 120,
    key: 'employees-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 1,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 120,
    key: 'employees-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 4,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 120,
    key: 'employees-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 2,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 120,
    key: 'employees-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 3,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 120,
    key: 'employees-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    permissionId: 5,
    appId: apps.dashboard.id,
    moduleId: 6,
    featureId: 121,
    key: 'details-button-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];

export const newPermissionTableVisibleForMpos = [
  {
    roleId: 4,
    userId: null,
    permissionId: 5,
    appId: apps.mpos.id,
    moduleId: 15,
    featureId: 47,
    key: 'table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleId: 5,
    userId: null,
    permissionId: 5,
    appId: apps.mpos.id,
    moduleId: 15,
    featureId: 47,
    key: 'table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleId: 6,
    userId: null,
    permissionId: 5,
    appId: apps.mpos.id,
    moduleId: 15,
    featureId: 47,
    key: 'table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleId: 8,
    userId: null,
    permissionId: 5,
    appId: apps.mpos.id,
    moduleId: 15,
    featureId: 47,
    key: 'table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleId: 9,
    userId: null,
    permissionId: 5,
    appId: apps.mpos.id,
    moduleId: 15,
    featureId: 47,
    key: 'table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleId: 10,
    userId: null,
    permissionId: 5,
    appId: apps.mpos.id,
    moduleId: 15,
    featureId: 47,
    key: 'table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: apps.mpos.id,
    moduleId: 15,
    featureId: 47,
    key: 'table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleId: 14,
    userId: null,
    permissionId: 5,
    appId: apps.mpos.id,
    moduleId: 15,
    featureId: 47,
    key: 'table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleId: 15,
    userId: null,
    permissionId: 5,
    appId: apps.mpos.id,
    moduleId: 15,
    featureId: 47,
    key: 'table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];

/****Accounting Permissions ************/
export const userPermissionV3Accounts: {
  roleKey: `${UserRoleType}`;
  userId: string | null;
  permissionId: (typeof permissionList)[number]['id'];
  appId: (typeof appList)[number]['id'];
  moduleId: (typeof moduleList)[number]['id'];
  featureId: (typeof featureListV3Accounts)[number]['id'] | null;
  key: string;
  isGranted: boolean;
  isApprovalNeeded: boolean;
  permissionLevel: `${PermissionLevel}`;
  type: 'Role';
  status: `${RecordStatus}`;
  createdBy: 'System';
}[] = [
  // ***** Accountant permissions ***** //

  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Visible.id, //visible
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: null,
    key: 'accounting-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Chart of acccount ***

  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  // *** Bill Payment ***

  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Journal Entry ***

  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['journal-entry'].id,
    key: 'journal-entry-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['journal-entry'].id,
    key: 'journal-entry-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['journal-entry'].id,
    key: 'journal-entry-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    roleKey: 'accountant',
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['journal-entry'].id,
    key: 'journal-entry-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    roleKey: 'accountant',
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['journal-entry'].id,
    key: 'journal-entry-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Reconcilition ***

  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Sales Controller ***

  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'accountant',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // ***** Owner permissions ***** //

  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: null,
    key: 'accounting-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Chart of acccount ***

  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Bill Payment ***

  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Journal Entry ***

  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['journal-entry'].id,
    key: 'journal-entry-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['journal-entry'].id,
    key: 'journal-entry-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['journal-entry'].id,
    key: 'journal-entry-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    roleKey: 'owner',
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['journal-entry'].id,
    key: 'journal-entry-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    userId: null,
    roleKey: 'owner',
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['journal-entry'].id,
    key: 'journal-entry-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Reconcilition ***

  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Sales Controller ***

  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'owner',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // ***** Manager Permissions *****

  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: null,
    key: 'accounting-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Chart of acccount ***

  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Bill Payment ***

  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Reconcilition ***

  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Sales Controller ***

  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'manager',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // ***** GM Permissions *****

  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: null,
    key: 'accounting-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Chart of acccount ***

  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Bill Payment ***

  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Reconcilition ***

  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['reconciliation'].id,
    key: 'reconciliation-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Sales Controller ***

  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Create.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Edit.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    roleKey: 'gm',
    userId: null,
    permissionId: permissions.Delete.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // ***** Shift or Assistant Manager Permissions

  {
    roleKey: 'shift-or-assistant-manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: null,
    key: 'accounting-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Chart of acccount ***

  {
    roleKey: 'shift-or-assistant-manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'shift-or-assistant-manager',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['chart-of-accounts'].id,
    key: 'chart-of-accounts-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Bill Payment ***

  {
    roleKey: 'shift-or-assistant-manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'shift-or-assistant-manager',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['bill-payments'].id,
    key: 'bill-payments-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Journal Entry ***

  {
    roleKey: 'shift-or-assistant-manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['journal-entry'].id,
    key: 'journal-entry-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'shift-or-assistant-manager',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['journal-entry'].id,
    key: 'journal-entry-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  // *** Sales Controller ***

  {
    roleKey: 'shift-or-assistant-manager',
    userId: null,
    permissionId: permissions.Visible.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },

  {
    roleKey: 'shift-or-assistant-manager',
    userId: null,
    permissionId: permissions.Read.id,
    appId: apps.dashboard.id,
    moduleId: 30,
    featureId: featuresV3['sales-controller'].id,
    key: 'sales-controller-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];
